// assets

import WarehouseOutlinedIcon from '@mui/icons-material/WarehouseOutlined';
import LocalShippingOutlinedIcon from '@mui/icons-material/LocalShippingOutlined';
import ShareLocationOutlinedIcon from '@mui/icons-material/ShareLocationOutlined';
import MonetizationOnOutlinedIcon from '@mui/icons-material/MonetizationOnOutlined';
import SellOutlinedIcon from '@mui/icons-material/SellOutlined';
import EventOutlinedIcon from '@mui/icons-material/EventOutlined';
// icons
const icons = {
    WarehouseOutlinedIcon,
    LocalShippingOutlinedIcon,
    ShareLocationOutlinedIcon,
    MonetizationOnOutlinedIcon,
    SellOutlinedIcon,
    EventOutlinedIcon
};

// ==============================|| MENU ITEMS - EXTRA PAGES ||============================== //

const pages = {
    id: 'warehousing',
    title: 'Warehouse & Inventory',
    type: 'group',
    subscriptionRequired: ['basic','standard','premium','enterprise','admin'],
    children: [
        {
            id: 'products',
            title: 'Products',
            type: 'item',
            url: '/products',
            icon: icons.SellOutlinedIcon,
            target: false,
            showInShopifyApp: true,
        },
        {
            id: 'orders',
            title: 'Orders',
            type: 'item',
            url: '/orders',
            icon: icons.MonetizationOnOutlinedIcon,
            target: false,
            showInShopifyApp: true,
        },
        {
            id: 'tracking',
            title: 'Tracking Numbers',
            type: 'item',
            url: '/tracking',
            icon: icons.ShareLocationOutlinedIcon,
            target: false,
            showInShopifyApp: false,
        },
        {
            id: 'warehouses',
            title: 'Warehouses',
            type: 'item',
            url: '/warehouses',
            icon: icons.WarehouseOutlinedIcon,
            target: false,
            showInShopifyApp: true,
        },
        {
            id: 'carriers',
            title: 'Shipping Carriers',
            type: 'item',
            url: '/carriers',
            icon: icons.LocalShippingOutlinedIcon,
            target: false,
            showInShopifyApp: true,
        },
        {
            id: 'holidays',
            title: 'Holidays',
            type: 'item',
            url: '/holidays',
            icon: icons.EventOutlinedIcon,
            target: false,
            showInShopifyApp: true,
        },
    ]
};

export default pages;
